<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>仓库基本配置</div>
    </div>

    <el-row class="filter">
      <div
        style="width: 80%;margin: 0 auto;margin-top: 20px;margin-bottom: 20px"
      >
        <el-form
          ref="form"
          :model="form"
          label-width="160px"
          class="demo-ruleForm"
        >
          <p>打印机配置</p>
          <el-button @click="addDevice()">增加打印机</el-button>
          <el-form-item
            v-for="(device, index) in form.print_devices"
            :key="device.key"
            :prop="'device.' + index + '.value'"
          >
            <el-input
              v-model="device.name"
              placeholder="打印机名称："
              style="width: 25%;float: left"
            ></el-input>
            <el-input
              v-model="device.ip"
              placeholder="IP地址"
              style="width: 25%;float: left"
            >
            </el-input>
            <el-input
              v-model="device.port"
              placeholder="端口"
              style="width: 25%;float: left"
            >
            </el-input>
            <el-button @click.prevent="removeDevice(device)">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <el-row> </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global";
export default {
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      form: {
        print_devices: [
          {
            name: "",
            ip: "",
            port: "",
          },
        ],
      },
      loading: false,
      tableLoading: false,
      url: "/erp/WavePicking/setDevices",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    removeDevice(item) {
      var index = this.form.print_devices.indexOf(item);
      if (index !== -1) {
        this.form.print_devices.splice(index, 1);
      }
    },
    addDevice() {
      this.form.print_devices.push({
        name: "",
        ip: "",
        port: "",
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form = res.data.data;
        }
      });
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/PrintDevices.vue